import { render } from "./EntityDetail.vue?vue&type=template&id=48ceadb7&scoped=true&ts=true"
import script from "./EntityDetail.vue?vue&type=script&lang=ts"
export * from "./EntityDetail.vue?vue&type=script&lang=ts"

import "./EntityDetail.vue?vue&type=style&index=0&id=48ceadb7&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ceadb7"],['__file',"src/views/modules/insights/views/EntityDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48ceadb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48ceadb7', __exports__)) {
    api.reload('48ceadb7', __exports__)
  }
  
  module.hot.accept("./EntityDetail.vue?vue&type=template&id=48ceadb7&scoped=true&ts=true", () => {
    api.rerender('48ceadb7', render)
  })

}


export default __exports__